import { Component } from 'react'

/**
 * Catches render errors so one broken screen doesn't blank the whole app.
 *
 * Class component because that is the only way React exposes
 * componentDidCatch — there is no hook equivalent.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Render error:', error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div style={{ padding: 40, maxWidth: 640 }}>
        <h1>Something broke on this screen</h1>
        <p className="sub">
          The rest of the app is fine. Reload to continue — and if it keeps happening, the
          message below is what a bug report needs.
        </p>
        <pre
          style={{
            background: 'var(--surface-2)',
            border: '1px solid var(--hairline)',
            borderRadius: 10,
            padding: 14,
            fontSize: 12.5,
            whiteSpace: 'pre-wrap',
            color: 'var(--text-mid)',
          }}
        >
          {String(this.state.error?.message || this.state.error)}
        </pre>
      </div>
    )
  }
}
